export default class MenuComponent{

	constructor(){

    this.toggleMenu = this.toggleMenu.bind(this);
    this.eventHandlers = this.eventHandlers.bind(this);

		this.eventHandlers();
	}

	eventHandlers(){
    $('.mobile-nav').on('click', this.toggleMenu);
    $(document).on('click', '.close-box, .backdrop', this.toggleMenu);
		//$(window).on('scroll', this.userScrolling);
	}

	toggleMenu(e){
    const el = $(e.currentTarget);

    // Add opened class to body
    $("body").toggleClass("opened");

    // Add backdrop if doesn't exist
    var thisTargetClass = el.data("target");
    if ( !$( '.backdrop.target-'+thisTargetClass).length ) {
      $('body').append('<div class="backdrop target-'+thisTargetClass+'" data-target="'+thisTargetClass+'"></div>');

    // Else, remove it
    }else{
      $('.backdrop.target-'+thisTargetClass).remove();
    }
	}

	/* userScrolling(evt){
		var scrollTop = $(window).scrollTop();

		var checkTop = $(".banner").position().top;

		if($(".gov-header")){
			checkTop = checkTop-$(".gov-header").height();
		}

		if ( scrollTop > checkTop) {
			$(".banner").addClass("scrolled");
		}else{
			$(".banner").removeClass("scrolled");
		}
	} */
}



// WEBPACK FOOTER //
// ./scripts/components/menu.js